export function buildQueryString(params) {
  if (!params || typeof params !== "object") {
    return "";
  }
  return Object.keys(params)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join("&");
}
